import { DataService } from "../Services/dataService";
import { getStorage, getDownloadURL, ref } from "firebase/storage";
import { FirebaseService } from "../Services/firebaseService";


declare var window: any;
export class VideoPage {

    videoElements = 10;

    dataService: DataService;
    firebaseService: FirebaseService;

    constructor() {
        this.dataService = new DataService();
        this.firebaseService = new FirebaseService();
        this.initVideo();
    }

    async initVideo() {
        await this.waitForArtPlayer();
        for (let i = 1; i <= this.videoElements; i++) {
            this.loadVideo("video" + i, i, await this.getPosterUrl(i.toString()));
        }
    }
    async getPosterUrl(name: string) {

        const storage = getStorage();
        let url = await getDownloadURL(ref(storage, 'videos/' + name + '.png'));
        return url;
    }

    async waitForArtPlayer(): Promise<any> {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (window.Artplayer) {
                    clearInterval(interval);
                    resolve(window.Artplayer);
                }
            }, 50);
        });
    }

    async loadVideo(elementId: string, index: number, poster: string) {

        const art = new window.Artplayer({
            container: '#' + elementId,
            poster: poster,
            autoSize: true,
            autoMini: false,
            fullscreen: true,
            fullscreenWeb: true,
            pip: false,
            mutex: true,
            theme: '#82eeab',
            lang: navigator.language.toLowerCase(),
            moreVideoAttr: {
                preload: 'none',
            },
        });

        let loaded = false;
        art.on('video:play', async (...args: any) => {
            if (!loaded) {
                let url = await this.dataService.getVideoURL(await this.firebaseService.getUserIdToken(), index);
                art.url = url[0];
                loaded = true;
                art.play();
            }
        });
    }
}